import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, NavLink } from 'react-router-dom';
import pb from '../lib/pocketbase';

function ResetPasswordPage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');

    const [password, setPassword] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    useEffect(() => {
        if (!token) {
            setError("Jeton de réinitialisation manquant ou invalide. Veuillez cliquer sur le lien dans votre email.");
        }
    }, [token]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!token) return;
        if (password !== passwordConfirm) {
            setError("Les mots de passe ne correspondent pas.");
            return;
        }

        setLoading(true);
        setError('');
        try {
            await pb.collection('users').confirmPasswordReset(token, password, passwordConfirm);
            setSuccess("Mot de passe modifié avec succès ! Vous pouvez maintenant vous connecter.");
            setTimeout(() => navigate('/connexion'), 3000);
        } catch (err) {
            console.error(err);
            setError("Erreur : Le lien a peut-être expiré ou est invalide.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ minHeight: '65vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem 1rem' }}>
            <div style={{ maxWidth: 520, width: '100%', background: 'var(--light-color)', color: 'var(--text-color)', border: '1px solid var(--border-color-extra-light, #e7e7e7)', borderRadius: 12, boxShadow: '0 10px 30px rgba(0,0,0,0.08)' }}>
                <div style={{ padding: '20px 20px 0', borderBottom: '1px solid var(--border-color-extra-light, #e7e7e7)', marginBottom: 16 }}>
                    <h1 style={{ fontSize: 24, margin: 0, textAlign: 'center' }}>Nouveau mot de passe</h1>
                </div>
                <div style={{ padding: '0 20px 20px' }}>
                    {error && <div style={{ background: '#fef2f2', color: '#dc2626', padding: '10px 12px', borderRadius: 8, marginBottom: 10, borderLeft: '4px solid #dc2626' }}>{error}</div>}
                    {success && <div style={{ background: '#f0fdf4', color: '#16a34a', padding: '10px 12px', borderRadius: 8, marginBottom: 10, borderLeft: '4px solid #16a34a' }}>{success}</div>}

                    {!success && (
                        <form onSubmit={handleSubmit}>
                            <div style={{ marginBottom: 12 }}>
                                <label htmlFor="password" style={{ display: 'block', marginBottom: 6, fontWeight: 600 }}>Nouveau mot de passe</label>
                                <input
                                    id="password"
                                    type="password"
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                    required
                                    minLength={8}
                                    style={{ width: '100%', padding: '12px 14px', border: '2px solid var(--border-color-extra-light,#e5e7eb)', borderRadius: 8 }}
                                />
                            </div>
                            <div style={{ marginBottom: 12 }}>
                                <label htmlFor="passwordConfirm" style={{ display: 'block', marginBottom: 6, fontWeight: 600 }}>Confirmer le mot de passe</label>
                                <input
                                    id="passwordConfirm"
                                    type="password"
                                    value={passwordConfirm}
                                    onChange={e => setPasswordConfirm(e.target.value)}
                                    required
                                    minLength={8}
                                    style={{ width: '100%', padding: '12px 14px', border: '2px solid var(--border-color-extra-light,#e5e7eb)', borderRadius: 8 }}
                                />
                            </div>
                            <button type="submit" disabled={loading || !token} style={{ width: '100%', background: 'linear-gradient(135deg,#3b82f6 0%,#1d4ed8 100%)', color: '#fff', border: 'none', padding: '12px 16px', borderRadius: 8, fontWeight: 700, cursor: 'pointer', opacity: (loading || !token) ? 0.7 : 1 }}>
                                {loading ? 'Modification...' : 'Modifier le mot de passe'}
                            </button>
                        </form>
                    )}

                    <div style={{ textAlign: 'center', paddingTop: 16, borderTop: '1px solid var(--border-color-extra-light,#e5e7eb)', marginTop: 16 }}>
                        <NavLink to="/connexion" style={{ color: 'var(--primary-color)', fontWeight: 700, textDecoration: 'underline' }}>Retour à la connexion</NavLink>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ResetPasswordPage;
